(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  try { paused = paused || localStorage.getItem('bravik-motion') === 'off'; } catch {}
  const button = document.querySelector('[data-br-motion]');
  const apply = () => {
    document.documentElement.classList.toggle('br-motion-off', paused || reduced.matches);
    if (button) {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(paused || reduced.matches));
      button.textContent = paused || reduced.matches ? button.dataset.play : button.dataset.pause;
    }
  };
  button?.addEventListener('click', () => {
    paused = !paused;
    try { localStorage.setItem('bravik-motion', paused ? 'off' : 'on'); } catch {}
    apply();
  });
  reduced.addEventListener('change', apply);
  apply();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('br-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 0.08}) : null;
  const init = (root = document) => {
    root.querySelectorAll('[data-br-reveal]').forEach(el => {
      if (observer && !reduced.matches && el.getBoundingClientRect().top > innerHeight) {
        el.classList.add('br-reveal-ready');
        observer.observe(el);
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
